import { number, route, string } from 'react-router-typesafe-routes/dom';

import { railwayAppRoute } from 'app/router/routes';

const passengersRoute = route(
  'passengers',
  {},
  {
    ADD: route('add'),
  },
);

const ticketsRoute = route(
  'tickets',
  {},
  {
    ORDERS: route('orders'),
    ORDER: route('order/:id', { params: { id: number() } }),

    REPORT: route('report'),
  },
);

const passengerDetailsRoute = route(
  'passenger',
  {},
  {
    DETAILS: route(':passengerId', {
      params: { passengerId: number().defined() },
    }),
  },
);

const messagesRoute = route(
  'messages',
  {},
  {
    ADD: route('add'),
  },
);

const eventsRoute = route('events', {
  searchParams: { resourceId: string(), highDate: number(), lowDate: number() },
});

const usersRoute = route(
  'users',
  {},
  {
    ADD: route('add'),
  },
);

const rolesRoute = route(
  'roles',
  {},
  {
    ADD: route('add'),
    DETAILS: route(':roleId', { params: { roleId: number() } }),
  },
);

const userDetailsRoute = route(
  'user',
  {},
  {
    DETAILS: route(':id', { params: { id: number() } }),
  },
);
const tripsRoute = route('trips');
const tripRoute = route('trips/:id', { params: { id: number() } });

const profileRoute = route('profile');

const reportsRoute = route('reports', {}, { ADD: route('add') });
const reportRoute = route('report/:id', { params: { id: number() } });
const reportEditRoute = route('report-edit/:id', { params: { id: number() } });

const wagonSchemes = route('wagon-schemes');

const trainTypes = route('train-types');

const tariffs = route('tariffs');
const tariffPrices = route('tariff-prices');
const tariffProfiles = route(
  'tariff-profiles',
  {},
  {
    ADD: route('add'),
    DETAILS: route(':tariffProfileId', {
      params: { tariffProfileId: number() },
    }),
  },
);

const tariffZonesAll = route('tariff-zones');

const routes = route(
  'routes',
  {},
  {
    DETAILS: route(':routeId', { params: { routeId: number() } }),
  },
);

export const appRoute = route(
  railwayAppRoute.relativePath,
  {},
  {
    PERSONS: passengersRoute,
    PERSON: passengerDetailsRoute,

    TICKETS: ticketsRoute,

    TRIPS: tripsRoute,
    TRIP: tripRoute,

    WAGON_SCHEMES: wagonSchemes,

    MESSAGES: messagesRoute,
    EVENTS: eventsRoute,

    USERS: usersRoute,
    USER: userDetailsRoute,
    PROFILE: profileRoute,
    ROLES: rolesRoute,

    REPORTS: reportsRoute,
    REPORT: reportRoute,
    REPORT_EDIT: reportEditRoute,

    TRAIN_TYPES: trainTypes,

    TARIFFS: tariffs,
    TARIFF_PRICES: tariffPrices,
    TARIFF_PROFILES: tariffProfiles,

    TARIFF_ZONES: tariffZonesAll,

    ROUTES: routes,
  },
);
